export default __webpack_public_path__ + "static/media/500.1017e532.woff2";